import React from 'react';

import { PluginSlot } from '@openedx/frontend-plugin-framework';

const UserMenuGroupSlot = () => (
  <PluginSlot
    id="header_user_menu_group_slot"
  />
);

export default UserMenuGroupSlot;
